var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2803 6.96561C10.9874 6.6573 10.5126 6.6573 10.2197 6.96561L7.895 9.41263C7.81615 9.49563 7.68385 9.49563 7.605 9.41263L5.28033 6.96561C4.98744 6.6573 4.51256 6.6573 4.21967 6.96561C3.92678 7.27392 3.92678 7.77378 4.21967 8.08209L7.025 11.0351C7.41925 11.4501 8.08075 11.4501 8.475 11.0351L11.2803 8.08209C11.5732 7.77378 11.5732 7.27392 11.2803 6.96561Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownward);
export default __webpack_public_path__ + "static/media/arrow-downward.ddf1696026ae5cd2d2ebcfc18b85bee2.svg";
export { ForwardRef as ReactComponent };